import ImageGridPortrait from './ImageGridPortrait'


export default ImageGridPortrait
